module.exports = __webpack_public_path__ + "static/media/img_monumento.69310ea7.jpg";